/* import __COLOCATED_TEMPLATE__ from './hero.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();